<template>
    <div component="ProfileDetailHeader" :buttonBack="hasBackButton" :buttonClose="hasCloseButton">
        <div class="holder">
            <h2>
                <i class="icon">{{ icon }}</i
                >{{ text }}
                <v-progress-linear :active="loading" :indeterminate="loading"></v-progress-linear>
            </h2>
            <btn
                class="close"
                :class="{ visible: getIsSetActorAccessToken }"
                v-if="hasCloseButton"
                @click="goBack"
                size="icon"
                color="ghost"
                :icon="'close'"
            />
            <slot />
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'ProfileDetailHeader',

    props: {
        text: {
            type: String,
            required: false,
        },

        icon: {
            type: String,
            required: false,
        },

        hasBackButton: {
            type: Boolean,
            required: false,
            default: false,
        },

        hasCloseButton: {
            type: Boolean,
            required: false,
            default: false,
        },

        loading: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    computed: {
        ...mapGetters(['getIsSetActorAccessToken']),
    },

    methods: {
        goBack(event) {
            window.history.back();
        },
    },

    components: {},
};
</script>
<style lang="less" scoped>
@import '~@variables';

[component='ProfileDetailHeader'] {
    height: 40px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    //flex-direction: row-reverse;

    @media (min-width: 769px) {
        background: transparent;
        border-width: 0;

        a.close {
            display: none;
        }
    }

    .v-progress-linear {
        border-radius: 0 0 10px 10px;
        position: absolute;
        bottom: 1px;
        width: 100%;
        left: 0;
    }

    .logo {
        position: absolute;
        left: 0;
        top: 0;
    }

    .holder {
        .flex-center;
        justify-content: space-between;
        flex: 1;
        position: relative;

        @media (min-width: 769px) {
            background: #eee;
            padding: 10px 15px;
            border-radius: 50px;
        }
    }

    h2 {
        display: flex;
        align-items: flex-end;
        line-height: 1.2;
        text-transform: uppercase;
        flex: 1;
        position: relative;
        font-weight: 900;

        i {
            margin-right: 5px;
        }
    }

    button.close {
        position: absolute;
        display: none;

        &.visible {
            @media (max-width: 768px) {
                top: 10px;
                right: 45px;
                display: flex;
            }
        }

        @media (min-width: 769px) {
            top: 7px;
            right: 7px;
            display: flex;
        }
    }
}
</style>
